import { useEffect, useMemo, useState } from 'react';
import { useTranslation } from '../../context/TranslationContext.jsx';

export const useTranslatedText = (text, options = {}) => {
  const { dynamic = false } = options;
  const { tStatic, tEvent } = useTranslation();
  const src = useMemo(() => (typeof text === 'string' ? text : ''), [text]);
  const [value, setValue] = useState(dynamic ? src : tStatic(src));

  useEffect(() => {
    if (!dynamic) {
      setValue(tStatic(src));
      return;
    }

    let cancelled = false;
    const out = tEvent(src);

    if (!out || typeof out === 'string') {
      setValue(out || '');
      return () => {
        cancelled = true;
      };
    }

    setValue(src); // show original immediately while translating
    out
      .then((translated) => {
        if (!cancelled) setValue(typeof translated === 'string' ? translated : src);
      })
      .catch(() => {
        if (!cancelled) setValue(src);
      });

    return () => {
      cancelled = true;
    };
  }, [dynamic, src, tEvent, tStatic]);

  return value;
};
